import SearchBar from "components/base/SearchBar";
import { currencySymbol } from "pages/price/PriceWithCurrency";
import { Link, useSearchParams } from "react-router-dom";

const CustomersView = ({ customers }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);
  const startYear = searchParams.get("startYear");
  const endYear = searchParams.get("endYear");
  const currency = searchParams.get("currency") || "USD";
  const customerSearch = searchParams.get("customerSearch") || "";
  const normalizedCustomerSearch = customerSearch.trim().toLowerCase();

  function getCustomerReportPath(customerId) {
    const nextSearch = new URLSearchParams();
    if (startYear) nextSearch.set("startYear", startYear);
    if (endYear) nextSearch.set("endYear", endYear);
    if (currency) nextSearch.set("currency", currency);

    const queryString = nextSearch.toString();
    return queryString ? `${customerId}?${queryString}` : `${customerId}`;
  }

  const filteredCustomers = customers.filter((customer) => {
    if (!normalizedCustomerSearch) return true;

    return (
      String(customer.customer_id || "").includes(normalizedCustomerSearch) ||
      String(customer.customer_name || "")
        .toLowerCase()
        .includes(normalizedCustomerSearch)
    );
  });

  return (
    <div className="card">
      <h5>Customers</h5>
      <div className="mt-4">
        <SearchBar
          value={customerSearch}
          placeholder="Search by customer name or id"
          onChange={(value) => {
            const nextParams = { ...params };
            const nextValue = value.trim();

            if (nextValue) {
              nextParams.customerSearch = nextValue;
            } else {
              delete nextParams.customerSearch;
            }

            setSearchParams(nextParams);
          }}
        />
        <div className="mt-2 -mx-2 max-h-96 overflow-auto">
          <table className="with-line">
            <tbody>
              {filteredCustomers.map((customer) => (
                <tr key={customer.customer_id}>
                  <td>
                    <Link to={getCustomerReportPath(customer.customer_id)}>
                      {customer.customer_name}
                    </Link>
                  </td>
                  <td className="text-right whitespace-nowrap font-code">
                    {currencySymbol(currency)}{" "}
                    {customer.total_amount_in_target_currency.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomersView;
